import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import generatecertificateapi from '../api/generatecertificateapi';
import loginapi from '../api/login';
import { APISERVERURL } from '../APIServerURL';

const SingleCertificate = ({ certificate ,accessToken,setAccessToken,setRefreshFailed}) => {
  const [formData, setFormData] = useState({ ...certificate });
  const navigate = useNavigate();


  function downloadFile(fname)
      {
        fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
          response.blob().then((blob) => {         
              // Creating new object of PDF file
              const fileURL =
                  window.URL.createObjectURL(blob);
                   
              // Setting various property values
              let alink = document.createElement("a");
              alink.href = fileURL;
              alink.download = fname;
              alink.click();
          });
        });
      }
  const handleUpdate=async (e)=>{
       try{
         const response= await generatecertificateapi.post('/updateCertificateDetails',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});    
         alert(JSON.stringify('UPDATED'));
       }
       catch(err)
       {
         if( err.response.status===403)
           {
             navigate(`/accessdenied`); 
           }
         try{
           const config = { withCredentials: true };
           const x=await loginapi.get('/getAccessToken',config);
           //alert(JSON.stringify(x['data']['accessToken']));
           
           const nat=x['data']['accessToken'];
           setAccessToken(nat);
           
           setRefreshFailed(false);  
           //console.log(`ne at ${nat}`);
           //console.log(`Second at:${accessToken}`);
           //alert('ok');
           try{       
             const response= await generatecertificateapi.post('/updateCertificateDetails',formData,{headers:{'Authorization':`Bearer ${nat}`}});    
             alert(JSON.stringify('UPDATED'));
            }
            catch(err)
            {
             if( err.response.status===403)
               {
                 navigate(`/accessdenied`); 
               }
               
               setRefreshFailed(true);  
             alert('unusual error newposts.js');
             //setIsAppLoaded(true);
             //alert(JSON.stringify(err));
             //navigate('/');
            }
         }
         catch(err)
         {
           alert(JSON.stringify(err));
           
           setRefreshFailed(true);  
           //setIsAppLoaded(true);
           //setError(JSON.stringify(err));
           //navigate('/');
         }
       }
       finally{
       }
  }
  const handleDownloadBG=async (e)=>{
    try{
      const response= await generatecertificateapi.post('/downloadSingleCertificate',{id:formData._id,bg:'YES',rollno:formData.rollno,type:formData.type},{headers:{'Authorization':`Bearer ${accessToken}`}});    
      alert(response.data);
        downloadFile(response.data);
    }
    catch(err)
    {
      if( err.response.status===403)
        {
          navigate(`/accessdenied`); 
        }
      try{
        const config = { withCredentials: true };
        const x=await loginapi.get('/getAccessToken',config);
        //alert(JSON.stringify(x['data']['accessToken']));
        
        const nat=x['data']['accessToken'];
        setAccessToken(nat);
        
        setRefreshFailed(false);  
        //console.log(`ne at ${nat}`);
        //console.log(`Second at:${accessToken}`);
        //alert('ok');
        try{       
          const response= await generatecertificateapi.post('/downloadSingleCertificate',{id:formData._id,bg:'YES',rollno:formData.rollno,type:formData.type},{headers:{'Authorization':`Bearer ${nat}`}});    
          alert(response.data);
        downloadFile(response.data);
         }
         catch(err)
         {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
            
            setRefreshFailed(true);  
          alert('unusual error newposts.js');
          //setIsAppLoaded(true);
          //alert(JSON.stringify(err));
          //navigate('/');
         }
      }
      catch(err)
      {
        alert(JSON.stringify(err));
        
        setRefreshFailed(true);  
        //setIsAppLoaded(true);
        //setError(JSON.stringify(err));
        //navigate('/');
      }
    }
    finally{
    }
}


const handleDownloadBare=async (e)=>{
  try{
    const response= await generatecertificateapi.post('/downloadSingleCertificate',{id:formData._id,bg:'NO',rollno:formData.rollno,type:formData.type},{headers:{'Authorization':`Bearer ${accessToken}`}});    
    alert(response.data);
      downloadFile(response.data);
  }
  catch(err)
  {
    if( err.response.status===403)
      {
        navigate(`/accessdenied`); 
      }
    try{
      const config = { withCredentials: true };
      const x=await loginapi.get('/getAccessToken',config);
      //alert(JSON.stringify(x['data']['accessToken']));
      
      const nat=x['data']['accessToken'];
      setAccessToken(nat);
      
      setRefreshFailed(false);  
      //console.log(`ne at ${nat}`);
      //console.log(`Second at:${accessToken}`);
      //alert('ok');
      try{       
        const response= await generatecertificateapi.post('/downloadSingleCertificate',{id:formData._id,bg:'NO',rollno:formData.rollno,type:formData.type},{headers:{'Authorization':`Bearer ${nat}`}});    
        alert(response.data);
      downloadFile(response.data);
       }
       catch(err)
       {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
          
          setRefreshFailed(true);  
        alert('unusual error newposts.js');
        //setIsAppLoaded(true);
        //alert(JSON.stringify(err));
        //navigate('/');
       }
    }
    catch(err)
    {
      alert(JSON.stringify(err));
      
      setRefreshFailed(true);  
      //setIsAppLoaded(true);
      //setError(JSON.stringify(err));
      //navigate('/');
    }
  }
  finally{
  }
}

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="w-full  bg-white shadow-md rounded-lg p-4">

     <div className="flex  mb-3 justify-between">
       <button className="px-4 py-2 bg-orange-600 text-white font-semibold rounded-lg shadow-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-opacity-75"
                onClick={handleDownloadBG}
        >
          download with BG
        </button>

        <button className="px-4 py-2 bg-gray-600 text-white font-semibold rounded-lg shadow-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-75"
                onClick={handleDownloadBare}
        >
          download Bare
        </button>
      </div>

      <div className="flex flex-col mb-3">
        <label className="text-sm font-semibold">Name</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="p-2 border-b-2 border-gray-300 bg-transparent outline-none"
        />
      </div>

      <div className="flex flex-col mb-3">
        <label className="text-sm font-semibold">Passing Year</label>
        <input
          type="text"
          name="passing_year"
          value={formData.passing_year}
          onChange={handleChange}
          className="p-2 border-b-2 border-gray-300 bg-transparent outline-none"
        />
      </div>

      <div className="flex flex-col mb-3">
        <label className="text-sm font-semibold">Honours</label>
        <input
          type="text"
          name="honours"
          value={formData.honours}
          onChange={handleChange}
          className="p-2 border-b-2 border-gray-300 bg-transparent outline-none"
        />
      </div>

      

      <div className="flex flex-col mb-3">
        <label className="text-sm font-semibold">Applied</label>
        <select
          name="applied"
          value={formData.applied}
          onChange={handleChange}
          className="p-2 border-b-2 border-gray-300 bg-transparent outline-none"
        >
          <option value="YES">YES</option>
          <option value="NO">NO</option>
        </select>
      </div>
            

      <div className="flex justify-center">
        <button className="px-4 py-2 bg-green-600 text-white font-semibold rounded-lg shadow-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-75"
                onClick={handleUpdate}
        >
          UPDATE
        </button>
      </div>
    </div>
  );
};

export default SingleCertificate;
